/**
 * Send message up to parent
 * @param {string} messageType
 * @param {string} messageValue
 */
 const sendMessageToParent = (messageType, messageValue) => {
    let message = {
        type: messageType,
        value: messageValue
    }
    window.top.postMessage(message, '*');
}

export default sendMessageToParent;